import router from '@/router'
import _ from 'lodash'
const system = {
  namespaced: true,
  state: () => ({
    loadingQueue: [], // 正在执行加载任务的ID队列标识
    openTabs: [], // 已经打开的tabs，用于多标签页面显示
    noCacheRouteList: ['apply-manage', 'metadata-manage', 'page-manage'] // 不缓存路由的页面
  }),
  mutations: {
    // loading相关
    startLoading: function (state, id) {
      state.loadingQueue.push(id)
    },
    stopLoading: function (state, id) {
      const index = state.loadingQueue.indexOf(id)
      if (index > -1) {
        const result = [].concat(state.loadingQueue)
        result.splice(index, 1)
        state.loadingQueue = result
      }
    },
    clearLoading: function (state) {
      state.loadingQueue = []
    },
    /**
     * 多标签页面相关
     */
    addTab: function (state, payload) {
      // 判断是否在已有的tab中, 已经存在则不需要压入
      const index = _.findIndex(state.openTabs, o => o.fullPath === payload.fullPath)
      if (!(index >= 0)) {
        state.openTabs.push({ meta: payload.meta, fullPath: payload.fullPath, path: payload.path, query: payload.query })
      }
    },
    removeTab: function (state, path) {
      if (state.openTabs.length === 1) return
      const index = _.findIndex(state.openTabs, o => o.fullPath === path)
      if (index >= 0) {
        state.openTabs.splice(index, 1)
        // 激活最后的一个标签页
        const target = state.openTabs[index] || state.openTabs[state.openTabs.length - 1]
        router.push({ path: target.path, query: target.query })
      }
    },
    setTabs: function (state, tabs) {
      state.openTabs = tabs.map(item => ({
        path: item.path,
        meta: item.meta
      }))
    },
    setTabTitle: function (state, { path, title }) {
      const index = _.findIndex(state.openTabs, o => o.fullPath === path)
      if (index >= 0) {
        const target = state.openTabs[index]
        Object.assign(target, { title })
      }
    },
    removeAllTabs: function (state) {
      state.openTabs = []
    }
  },
  actions: {
    clearLoading: function ({ commit }) {
      commit('clearLoading')
    },
    startLoading: function ({ commit }) {
      const loadingId = _.uniqueId('loading_')
      commit('startLoading', loadingId)
      return loadingId
    },
    stopLoading: function ({ commit }, id) {
      setTimeout(() => {
        commit('stopLoading', id)
      }, 0)
    },
    /**
     * 多标签页面加载相关
     */
    addTab: function ({ commit }, payload) {
      commit('addTab', payload)
    },
    closeTab: function ({ commit }, path) {
      commit('removeTab', path)
    },
    removeBehindTab: function ({ commit, state }, path) {
      const index = _.findIndex(state.openTabs, o => o.path === path)
      const openTabs = [].concat(state.openTabs)
      openTabs.splice(index + 1)
      commit('setTabs', openTabs)
    },
    removeOtherTabs: function ({ commit, state }, path) {
      const target = _.find(state.openTabs, o => o.path === path)
      const openTabs = [target]
      commit('setTabs', openTabs)
    },
    // 单独设置标签标题
    setTabTitle: function ({ commit, state }, { path, title }) {
      commit('setTabTitle', { path, title })
    },
    // 清空所有的标签
    removeAllTabs: function ({ commit }) {
      commit('removeAllTabs')
    }
  },
  getters: {
    loading: (state) => {
      return state.loadingQueue.length > 0
    },
    openTabs: (state) => {
      return JSON.parse(JSON.stringify(state.openTabs))
    },
    noCacheRouteList: (state) => {
      return state.noCacheRouteList || []
    }
  }
}

export default system
